import React from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import { AmchartSeeker } from '@ui-seeker/core'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { POSITION_MAIN_COLOR } from 'Pages/AnalyzersV2/@constants'
import { buildMarketBandData, findMainKey } from 'Pages/AnalyzersV2/@components/MarketBandChart/@utils'
import RankStrip from 'Pages/AnalyzersV2/@components/MarketBandChart/RankStrip'
import ChartFullScreen from 'Pages/AnalyzersV2/@components/ChartFullScreen'

const BAND_COLOR = '#8a97a6'


export default function MarketBandChart({ marketChartData, totalBrands }) {
	if (isAnalyzerLoading.value) return <Skeleton variant="rectangular" height={500}/>
	if (!marketChartData?.length) return <></>

	const mainKey = findMainKey(marketChartData)

	if (!mainKey) return <></>

	const data = buildMarketBandData(marketChartData, mainKey)

	return <Box>
		<ChartFullScreen rootID="MarketBandChart" renderChart={viewProps => <AmchartSeeker
			{...viewProps}
			title={<Box>
				<Typography variant="h4">Position over time</Typography>
				<Typography variant="caption" sx={{ color: 'text.secondary' }}>
					{mainKey} vs. competitor price band, by pickup date
				</Typography>
			</Box>}
			data={data}
			// Pickup dates are not consecutive (every 2-5 days further out), so time
			// gaps must not break the lines; only missing values do.
			series={[{
				// Competitor min–max band, drawn first so the lines sit on top of it.
				name: 'Competitor range',
				yField: 'maxPrice',
				xField: 'date',
				openValueYField: 'minPrice',
				color: BAND_COLOR,
				connect: false,
				autoGapCount: Infinity,
				tension: 1,
				fills: { fillOpacity: .18, visible: true },
				strokes: { strokeOpacity: 0 },
				bullets: { hidden: true },
				tooltip: { labelText: 'Competitor range: {openValueY} - {valueY}' },
			}, {
				name: 'Market average',
				yField: 'avgPrice',
				xField: 'date',
				color: BAND_COLOR,
				connect: false,
				autoGapCount: Infinity,
				tension: 1,
				strokes: { strokeWidth: 2, strokeDasharray: [5, 4] },
				bullets: { hidden: true },
			}, {
				name: mainKey,
				yField: 'main',
				xField: 'date',
				color: POSITION_MAIN_COLOR,
				connect: false,
				autoGapCount: Infinity,
				tension: 1,
				strokes: { strokeWidth: 4 },
			}]}
			chartProps={{
				showBullets: true,
				enabledPDF: false,
				numberFormat: "#,###.00",
				dateFormatReceived: 'yyyyMMdd',
				// Horizontal is on unless hidden; vertical needs opting in.
				scrollbarX: { hidden: false },
				scrollbarY: { show: true },
				xAxis: {
					categoryField: 'date',
					maxDeviation: 0.3,
					isDateAxis: true,
					dateFormat: 'dd MMM yyyy (EEE)',
					baseInterval: { timeUnit: 'day', count: 1 },
				},
				yAxis: { title: 'Prices' },
			}}
		/>}/>

		<RankStrip rows={data} totalBrands={totalBrands}/>
	</Box>
}
